import http from "./http";

function login(data) {
  return http.post("login", data);
}

function changePasswordApi(data) {
  return http.post(`ForgotPassword`, data);
}

const authService = {
  login,
  changePasswordApi,
};

export default authService;
// ====================================
